<template>
	<div class="flex flex-grow">
		<div v-if="!isLoading">
			<PDFBlueprintsEdit :is-for-onboarding="true" :template-i-d-param="blueprintID" ref="PDFBlueprintsEdit" class="w-full" />
		</div>
		<LoadingSpinner v-else />
	</div>
</template>

<script>
import PDFBlueprintsEdit from '@/views/pdfblueprints/PDFBlueprintsEdit.vue';
import Validate from '@/mixins/Validate';
import PDFBlueprintRepository from '@/api/repositories/PDFBlueprintRepository';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';

export default {
	components: { LoadingSpinner, PDFBlueprintsEdit },
	name: 'OnboardingCompanyPDFBlueprints',
	mixins: [Validate],
	props: {
		value: {},
		blueprintID: null,
	},
	data() {
		return {
			isLoading: true,
		};
	},
	mounted() {
		this.isLoading = true;
		this.getBlueprints();
	},
	methods: {
		getData() {
			return { id: this.blueprintID, values: this.$refs.PDFBlueprintsEdit.getData() };
		},
		getBlueprints() {
			new PDFBlueprintRepository()
				.getAllBlueprints()
				.then(response => {
					this.blueprintID = response.data.find(element => element.label === 'Gutachtenauftrag').id;
					this.isLoading = false;
				})
				.catch(e => {
					this.$swal(this.$t('general.error').toString(), this.$t('values_cannot_be_fetched').toString(), 'error');
					this.isLoading = false;
				});
		},
	},
};
</script>
